import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DOSSIER',
  title: 'Come è organizzato una cartelle online?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'I vostri documenti sono suddivisi in varie sotto cartelle:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Obbligatorio: qui troverete i documenti obbligatori che costituiscono il La Cartella Legale'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DOSSIER/IT_DOSSIER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Mestiere: troverete tutti gli altri documenti relativi al vostro settore di attività nell\'ambito di un contratto di subappalto'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DOSSIER/IT_DOSSIER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Addizionale: vi troverete i documenti complementari per la vostra cartelle'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DOSSIER/IT_DOSSIER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Operazioni: qui troverete tutti i documenti relativi ad un\'operazione (Attestato Decennale Nominativo, Carta RSI...)'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_DOSSIER/IT_DOSSIER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Di fronte a ogni documento si ritrova lo stato del documento.'
  }]
};
